import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "asview" }
const _hoisted_2 = {
  class: "sui-card sui-card--flush",
  "data-tour": "admin-seller-view-list"
}
const _hoisted_3 = {
  class: "sui-toolbar",
  "data-tour": "admin-seller-view-toolbar"
}
const _hoisted_4 = { class: "sui-search" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "asview__error"
}
const _hoisted_7 = {
  key: 1,
  class: "sui-table-wrap"
}
const _hoisted_8 = { class: "sui-table" }
const _hoisted_9 = { class: "sui-table__strong" }
const _hoisted_10 = { class: "sui-table__sub" }
const _hoisted_11 = { class: "asview__id" }
const _hoisted_12 = { class: "is-center" }
const _hoisted_13 = { class: "is-center" }
const _hoisted_14 = ["disabled", "onClick"]
const _hoisted_15 = {
  key: 2,
  class: "asview__empty"
}

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import { fetchAdminSellers, impersonateAdminSeller, type AdminSellerRow } from '@/api/admin'
import { useSellerAuth } from '@/composables/useSellerAuth'
import { SELLER_STATUS_LABEL, type SellerStatus } from '@/constants/sellerSession'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminSellerViewPage',
  setup(__props) {

const router = useRouter()
const { applySession } = useSellerAuth()

const sellers = ref<AdminSellerRow[]>([])
const loading = ref(false)
const errorMessage = ref('')
const keyword = ref('')
const openingCode = ref('')

const STATUS_TONE: Record<SellerStatus, string> = {
  PENDING: 'sui-badge--violet',
  APPROVED: 'sui-badge--green',
  REJECTED: 'sui-badge--red',
  SUSPENDED: 'sui-badge--amber',
  CLOSED: 'sui-badge--gray',
}

function statusTone(status: SellerStatus) {
  return STATUS_TONE[status] ?? 'sui-badge--gray'
}

function canOpen(row: AdminSellerRow) {
  return row.status === 'APPROVED' || row.status === 'PENDING'
}

const filtered = computed(() => {
  const q = keyword.value.toLowerCase()
  return sellers.value.filter((row) => {
    if (!q) {
      return true
    }
    const hay = [row.sellerId, row.storeName, row.bizName, row.sellerCode]
      .join(' ')
      .toLowerCase()
    return hay.includes(q)
  })
})

async function load() {
  loading.value = true
  errorMessage.value = ''
  try {
    sellers.value = await fetchAdminSellers()
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '목록을 불러오지 못했습니다.'
  } finally {
    loading.value = false
  }
}

async function openAsSeller(row: AdminSellerRow) {
  if (!canOpen(row) || openingCode.value) {
    return
  }

  openingCode.value = row.sellerCode
  errorMessage.value = ''
  try {
    const seller = await impersonateAdminSeller(row.sellerCode)
    applySession(seller)
    const opened = window.open('/seller', '_blank')
    if (!opened) {
      await router.push({ name: 'seller-dashboard' })
    }
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '판매업체 화면을 열지 못했습니다.'
  } finally {
    openingCode.value = ''
  }
}

onMounted(load)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "asview__lead" }, " 최고관리자만 사용할 수 있습니다. 판매업체 아이디로 판매관리센터를 열면 그 업체가 보는 화면과 같습니다. 저장·처리도 해당 업체로 반영됩니다. 관리자 로그인은 그대로 유지됩니다. ", -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _createVNode(AppIcon, {
            icon: "mdi-magnify",
            size: 17
          }),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
            type: "search",
            placeholder: "아이디 · 상호 · 업체코드 검색"
          }, null, 512), [
            [
              _vModelText,
              keyword.value,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sui-toolbar__spacer" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "sui-btn",
          disabled: loading.value,
          onClick: load
        }, [
          _createVNode(AppIcon, {
            icon: "mdi-refresh",
            size: 16
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" 새로고침 ", -1))
        ], 8, _hoisted_5)
      ]),
      (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createVNode(AppIcon, {
              icon: "mdi-alert-outline",
              size: 16
            }),
            _createTextVNode(" " + _toDisplayString(errorMessage.value) + " ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "sui-btn sui-btn--sm",
              onClick: load
            }, "다시 시도")
          ]))
        : _createCommentVNode("", true),
      (filtered.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "업체"),
                  _createElementVNode("th", null, "아이디"),
                  _createElementVNode("th", { class: "is-center" }, "상태"),
                  _createElementVNode("th", { class: "is-center" }, "보기")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (row) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row.sellerCode
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(row.storeName || row.sellerId), 1),
                      _createElementVNode("span", _hoisted_10, _toDisplayString(row.sellerCode) + " · " + _toDisplayString(row.bizName || '—'), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(row.sellerId), 1)
                    ]),
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["sui-badge", statusTone(row.status)])
                      }, _toDisplayString(_unref(SELLER_STATUS_LABEL)[row.status]), 3)
                    ]),
                    _createElementVNode("td", _hoisted_13, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "sui-btn sui-btn--primary sui-btn--sm",
                        "data-tour": "admin-seller-view-open",
                        disabled: !canOpen(row) || openingCode.value === row.sellerCode,
                        onClick: ($event: any) => (openAsSeller(row))
                      }, _toDisplayString(openingCode.value === row.sellerCode ? '여는 중…' : '이 업체로 보기'), 9, _hoisted_14)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (!loading.value && !errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, " 조건에 맞는 판매업체가 없습니다. "))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})